import { motion } from "framer-motion";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-bone/10 bg-ink pt-24 md:pt-32 pb-10"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <motion.h2
          initial={{ y: 60, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1.1, ease: [0.19, 1, 0.22, 1] }}
          className="font-serif font-light text-[18vw] md:text-[13vw] leading-[0.82] tracking-tightest text-bone"
        >
          Come <span className="italic text-gold">in</span>.
        </motion.h2>

        <div className="mt-16 md:mt-24 grid grid-cols-12 gap-8 md:gap-12 border-t border-bone/10 pt-12">
          <div className="col-span-12 md:col-span-4 text-sm text-bone/60 font-light leading-relaxed">
            <div className="text-[11px] uppercase tracking-widest-2 text-bone/40 mb-4">Address</div>
            17 Foundry Lane<br />
            The Iron Quarter<br />
            Old Town, ZW1 4EM
          </div>
          <div className="col-span-6 md:col-span-4 text-sm text-bone/60 font-light leading-relaxed">
            <div className="text-[11px] uppercase tracking-widest-2 text-bone/40 mb-4">Hours</div>
            Mon — Fri · 07 — 19<br />
            Sat — Sun · 08 — 20<br />
            Kitchen closes at 16
          </div>
          <div className="col-span-6 md:col-span-4 text-sm text-bone/60 font-light leading-relaxed">
            <div className="text-[11px] uppercase tracking-widest-2 text-bone/40 mb-4">Reach</div>
            hello@ferrumember.co<br />
            +44 20 4577 0001<br />
            <span className="text-gold/80">@ferrumember</span>
          </div>
        </div>

        <div className="mt-16 md:mt-24 flex flex-col md:flex-row items-start md:items-end justify-between gap-6 text-[10px] uppercase tracking-widest-2 text-bone/40">
          <div>© MMXXV · Ferrum &amp; Ember · All beans reserved</div>
          <div>Menu Vol. 07 · The Winter Edition</div>
        </div>
      </div>
    </footer>
  );
};
